import { render, staticRenderFns } from "./newsletter-form.vue?vue&type=template&id=194190d0&lang=pug"
import script from "./newsletter-form.vue?vue&type=script&lang=ts"
export * from "./newsletter-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports